"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpreadsheet = void 0;
var fromPairs_1 = __importDefault(require("lodash/fromPairs"));
var react_1 = require("react");
var react_cool_virtual_1 = __importDefault(require("react-cool-virtual"));
var react_table_1 = require("react-table");
var fuzzyTableFilter_1 = require("../table/filters/fuzzyTableFilter");
var expandable_column_1 = require("./expandable-column");
var preferences_1 = require("./preferences");
var selectable_column_1 = require("./selectable-column");
var use_scroll_center_1 = require("./use-scroll-center");
var utils_1 = require("./utils");
function useSpreadsheet(_a) {
    var data = _a.data, columns = _a.columns, options = _a.options, globalFilter = _a.globalFilter, rowsToShow = _a.rowsToShow, heightProp = _a.height, rowHeight = _a.rowHeight, tableOptions = _a.tableOptions, state = _a.state, tableId = _a.tableId, onSelectedRowIds = _a.onSelectedRowIds, isRowSelectable = _a.isRowSelectable, disableToggleAllSelected = _a.disableToggleAllSelected, _b = _a.expandable, expandable = _b === void 0 ? false : _b, _c = _a.expandSubrows, expandSubrows = _c === void 0 ? false : _c, _d = _a.hideExpandColumn, hideExpandColumn = _d === void 0 ? false : _d, onScrollCenter = _a.onScrollCenter;
    var handleOnScrollCenter = (0, use_scroll_center_1.useOnScrollCenter)(data.length);
    var tableData = (0, react_1.useMemo)(function () { return data; }, [data]);
    var initialState = (0, preferences_1.useInitialTableState)({ tableId: tableId });
    var defaultColumn = (0, react_1.useMemo)(function () { return ({
        CellPopover: function () { return null; },
        minWidth: 60,
    }); }, []);
    var filterTypes = (0, react_1.useMemo)(function () { return ({
        fuzzy: fuzzyTableFilter_1.fuzzyTableFilter,
    }); }, []);
    var initialStateWithDefaultExpanded;
    if (expandable && expandSubrows) {
        initialStateWithDefaultExpanded = __assign(__assign({}, initialState), { expanded: Object.fromEntries(tableData.map(function (_row, index) { return [index, true]; })) });
    }
    var table = (0, react_table_1.useTable)(__assign({ data: tableData, defaultColumn: defaultColumn, columns: columns, autoResetResize: false, autoResetSortBy: false, autoResetSelectedRows: false, autoResetGlobalFilter: false, autoResetRowState: false, autoResetHiddenColumns: false, autoResetExpanded: false, autoResetFilters: false, autoResetGroupBy: false, autoResetPage: false, manualSortBy: !!(state === null || state === void 0 ? void 0 : state.sortBy), initialState: initialStateWithDefaultExpanded || initialState, isEditable: options === null || options === void 0 ? void 0 : options.isEditable, globalFilter: 'fuzzy', useControlledState: function (controlledState, meta) {
            return __assign(__assign(__assign({}, controlledState), state), { sortBy: (state === null || state === void 0 ? void 0 : state.sortBy) ? [state.sortBy] : controlledState.sortBy, selectedRowIds: (state === null || state === void 0 ? void 0 : state.selectedRowIds) ? mapSelectedRowsState(state.selectedRowIds) : {}, globalFilter: globalFilter });
        }, filterTypes: filterTypes }, tableOptions), react_table_1.useGlobalFilter, react_table_1.useSortBy, react_table_1.useExpanded, react_table_1.useFlexLayout, react_table_1.useResizeColumns, react_table_1.useRowSelect, (0, preferences_1.useLocalStoragePersistor)({ tableId: tableId }), (0, selectable_column_1.useSelectableColumn)({ onSelectedRowIds: onSelectedRowIds, isRowSelectable: isRowSelectable, disableToggleAllSelected: disableToggleAllSelected }), (0, expandable_column_1.useExpandableColumn)({ expandable: expandable, hideExpandColumn: hideExpandColumn }));
    var calculatedHeight = (0, utils_1.useTableHeight)({
        rowsToShow: rowsToShow,
        footerHeight: 48,
        headerHeight: 48,
        rowHeight: rowHeight,
    });
    var height = heightProp || calculatedHeight;
    var virtual = (0, react_cool_virtual_1.default)({
        itemCount: table.rows.length,
        itemSize: rowHeight,
        onScroll: onScrollCenter ? function (event) { return handleOnScrollCenter(event, onScrollCenter); } : undefined,
    });
    return {
        table: table,
        virtual: virtual,
        height: height,
    };
}
exports.useSpreadsheet = useSpreadsheet;
function mapSelectedRowsState(selectedRows) {
    return (0, fromPairs_1.default)(selectedRows.map(function (rowId) { return [rowId, true]; }));
}
